import axios, { AxiosPromise } from 'axios';

import { IStorageUnit } from '../../../@types/model/masterData/storageUnit/storageUnit';
import qs from 'qs';
import { IStorageUnitDashboard } from '../../../@types/model/masterData/storageUnit/storageUnitDashboardData';
import { IStorageUnitUpsert } from '../../../@types/model/masterData/storageUnit/storageUnitUpsert';

export default class StorageUnitHttpService {
    public static getStorageUnitData() : AxiosPromise<Array<IStorageUnit>> {
        return axios.get(`${API_URL}/v1/StorageUnit/GetAllWeb`);
    }

    public static getDashboardData(fromDateUnix ?: number, toDateUnix ?: number, siteIds ?: Array<number>, loadMasterData ?: boolean) : AxiosPromise<IStorageUnitDashboard> {
        return axios.get(`${API_URL}/v1/StorageUnit/DashboardData`, {
            params: {
                fromDateUnix,
                toDateUnix,
                siteIds,
                loadMasterData,
            },
            paramsSerializer: qs.stringify,
        });
    }

    public static addOrUpdateStorageUnit(upsert : IStorageUnitUpsert) : AxiosPromise<IStorageUnit> {
        return axios.post(`${API_URL}/v1/StorageUnit/PostStorageUnit`, upsert);
    }

    public static deleteStorageUnit(storageUnitId : number) : AxiosPromise<IStorageUnit> {
        return axios.delete(`${API_URL}/v1/StorageUnit/Delete`, {
            params : { storageUnitId },
        });
    }
}
